import { esc } from '@/utils/escape';

export function generateStickyCtaHTML(data: any, settings: any): string {
  const note = data.note
    ? `<div class="sticky-cta__note">${esc(data.note)}</div>`
    : "";
  const phone = data.phone
    ? `<a class="btn btn--ghost" href="tel:${esc(data.phone)}">${esc(data.phone)}</a>`
    : "";
  return `  <!-- Sticky CTA -->
  <div class="sticky-cta" role="region" aria-label="Call to action">
    <div class="container sticky-cta__inner">
      <div class="sticky-cta__text">
        <div class="sticky-cta__headline">${esc(data.text || "")}</div>
        ${note}
      </div>
      <div class="sticky-cta__actions">
        <a class="btn btn--primary" href="#kontakt">${esc(data.buttonText || "Termin vereinbaren")}</a>
        ${phone}
      </div>
    </div>
  </div>`;
}
